import "./static/css/styles.css"
